import MyEarnings from "../../../jsx/components/Dashboard/MyEarnings/MyEarnings";

const MyEarningsWrapper = () => {
  return <MyEarnings />;
};

export const allowedRoles = [
  _enum.ROUTE_PERSONAS.admin,
  _enum.ROUTE_PERSONAS.connector,
  _enum.ROUTE_PERSONAS.associate,
  _enum.ROUTE_PERSONAS.manager,
];

export default constore(MyEarningsWrapper);
